export default __webpack_public_path__ + "static/media/Leggings of the Blood God (nm).75b7d02b.jpg";